import { render } from "./AbsolutelyLayout.vue?vue&type=template&id=2fc2d10a&scoped=true"
import script from "./AbsolutelyLayout.vue?vue&type=script&lang=js"
export * from "./AbsolutelyLayout.vue?vue&type=script&lang=js"

import "./AbsolutelyLayout.vue?vue&type=style&index=0&id=2fc2d10a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc2d10a"]])

export default __exports__